import React, { useState } from 'react';

import Footer from '../components/Footer';
import Navbar from '../components/Navbar';


import image01 from '../assets/CardsImages/card-6-img/img-76.jpg'
import image02 from '../assets/CardsImages/card-6-img/img-77.jpg'
import image03 from '../assets/CardsImages/card-6-img/img-78.jpg'
import image04 from '../assets/CardsImages/card-6-img/img-79.jpg'
import image05 from '../assets/CardsImages/card-6-img/img-80.jpg'
import image06 from '../assets/CardsImages/card-6-img/img-81.jpg'
import image07 from '../assets/CardsImages/card-6-img/img-81.jpg'
import image08 from '../assets/CardsImages/card-6-img/img-82.jpg'
import image09 from '../assets/CardsImages/card-6-img/img-80.jpg'
import image10 from '../assets/CardsImages/card-6-img/img-84.jpg'
import image11 from '../assets/CardsImages/card-6-img/img-85.jpg'
import image12 from '../assets/CardsImages/card-6-img/img-86.jpg'
import image13 from '../assets/CardsImages/card-6-img/img-87.jpg'
import image14 from '../assets/CardsImages/card-6-img/img-88.jpg'
import image15 from '../assets/CardsImages/card-6-img/img-89.jpg'
import image16 from '../assets/CardsImages/card-6-img/img-90.jpg'

const Card06 = () => {


    
        const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image
    
        const images = [
            image01,
            image02,
            image03,
            image04,
            image05,
            image06,
            image07,
            image08,
            image09,
            image10,
            image11,
            image12,
            image13,
            image14,
            image15,
            image16
    
    
            // Add the rest of the images here...
        ];
    
        const handleImageClick = (image) => {
            setSelectedImage(image); // Set the selected image
        };
    
        const handleClose = () => {
            setSelectedImage(null); // Clear the selected image
        };
    
    
    return (

        <div>
            {/* <Navbar /> */}
            <div className="container mx-auto px-6 py-12 mt-8">
                <h1 className="text-3xl font-bold text-center text-purple-950 mb-8">Project & Shutdown Job</h1>
                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">
                    <h2 className="text-2xl font-semibold mb-4">Project & Shutdown Job</h2>
                    <p className="mb-4">
                    "Project and shutdown job" typically refers to a planned project that involves a temporary shutdown of a facility, unit, or specific equipment to perform maintenance, upgrades, modifications, or other significant work. This process is also known as a "plant turnaround" or "shutdown and turnaround." Here are the key aspects and steps involved in project and shutdown jobs:
                    </p>
                </div>

                <div className="container mx-auto px-4 py-8 my-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">1. Project Planning</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Define the scope and objectives of the project, including the specific tasks to be carried out during the shutdown.</li>
                                    <li>Develop a detailed project plan that includes timelines, resource allocation, and budgeting.</li>
                                    <li>Identify the project team members and their roles and responsibilities.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">2. Shutdown Preparation</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Schedule the shutdown during a time that minimizes production losses and aligns with business needs.</li>
                                    <li>Notify all relevant stakeholders, including employees, contractors, and regulatory authorities.</li>
                                    <li>Develop a detailed shutdown procedure that outlines the steps for safely shutting down the equipment or facility.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">3. Safety Precautions</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Prioritize safety throughout the project and shutdown process. Implement and enforce strict safety protocols and procedures.</li>
                                    <li>Conduct hazard assessments and ensure the availability of necessary safety equipment.</li>
                                    <li>Provide training to personnel on emergency response procedures.
                                    </li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">4. Resource Management</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Procure the required materials, equipment, spare parts, and contractor services.</li>
                                    <li>Ensure that all resources are available on-site and ready for use during the shutdown.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">5. Shutdown Execution</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Follow the shutdown procedure to safely and systematically shut down the equipment or facility.</li>
                                    <li>Carry out the planned maintenance, upgrades, inspections, repairs, and modifications.</li>
                                    <li>Replace or repair worn or damaged components.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">6. Inspection and Testing </h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Perform thorough inspections and testing of equipment to verify that it meets safety and performance standards.</li>
                                    <li>Conduct non-destructive testing (NDT) where necessary to assess the integrity of critical components.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">7. Continuous Monitoring</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Implement a monitoring and maintenance program to ensure the ongoing efficient operation of the equipment or facility.</li>
                                    <li>Schedule regular inspections and preventive maintenance activities.</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>


                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">

                    <p className="mb-4">
                    A well-planned and executed project and shutdown job is essential for maintaining the reliability, safety, and performance of industrial equipment and facilities. It helps prevent unplanned downtime, ensures regulatory compliance, and extends the lifespan of assets. Safety, efficient resource management, and thorough documentation are key elements in the success of these projects.
                    </p>
                </div>


                {/* All Work Section */}
                <div className="my-12 text-center">
                    <h2 className="text-2xl font-semibold text-purple-900 mb-4">All Work</h2>
                    <p className="text-lg text-gray-700 mb-4">We provide high standard work for your Company solutions</p>
                </div>

                {/* Images Section */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>


                    {/* Modal to show selected image */}
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                            <div className="relative">
                                <img
                                    src={selectedImage}
                                    alt="Selected"
                                    className="max-w-full max-h-screen rounded-lg"
                                />
                                <button
                                    onClick={handleClose}
                                    className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                                >
                                    ✖
                                </button>
                            </div>
                        </div>
                    )}
            </div>

            {/* <Footer /> */}
        </div>
    );
};

export default Card06;
